module.exports = __webpack_public_path__ + "dist/media/useraggrement.0a789da4.pdf";